import { lazy } from 'react';
/** Открывает карточку прайс-листа */
export const PriceListDetailsPageAsync = lazy(() => import('./PriceListDetails/PriceListDetailsPage'));